/* =====================================================================
   CASA · LEGAL AGREEMENTS + ELECTRONIC SIGNATURE
   Implements what Casa's attorney required of the web side: "ways for a person
   to accept (click) the terms and conditions for which they are using your
   website (buyer, seller, membership, etc.)".

   Documents are served from /api/legal (published verbatim from the attorney's
   .docx files) so the text on screen is the text of record. Accepting captures a
   typed signature, the signer's name, the exact document version + content hash,
   and the date — because an acceptance that only records "a box was ticked"
   proves nothing about WHAT was agreed to.
   ===================================================================== */
(function casaLegal(){
  'use strict';

  var API = '/api';
  var CTX_LABEL = {
    account:    { title: 'Before you create your account', verb: 'Create account' },
    purchase:   { title: 'Before you complete your purchase', verb: 'Continue to payment' },
    consignor:  { title: 'Before you consign with Casa', verb: 'Agree & continue' },
    membership: { title: 'Before you join the Casa Concierge Club', verb: 'Agree & continue' }
  };

  var style = document.createElement('style');
  style.textContent = [
    '.casa-legal-modal{position:fixed;inset:0;z-index:100000;background:rgba(10,20,33,.62);',
    'display:none;align-items:center;justify-content:center;padding:24px;}',
    '.casa-legal-modal.open{display:flex;}',
    '.casa-legal-card{background:#fff;max-width:760px;width:100%;max-height:88vh;display:flex;',
    'flex-direction:column;border-radius:2px;box-shadow:0 24px 70px rgba(0,0,0,.3);}',
    '.casa-legal-head{padding:22px 26px 16px;border-bottom:1px solid #e8e4dd;}',
    '.casa-legal-head h3{margin:0;font-family:Georgia,serif;font-weight:400;font-size:21px;color:#122A45;}',
    '.casa-legal-head p{margin:8px 0 0;font-size:13px;color:#6b6b6b;line-height:1.55;}',
    '.casa-legal-tabs{display:flex;gap:6px;padding:12px 26px 0;flex-wrap:wrap;}',
    '.casa-legal-tab{font-size:11px;letter-spacing:.1em;text-transform:uppercase;padding:7px 12px;',
    'border:1px solid #e0dcd4;background:#faf8f5;cursor:pointer;color:#122A45;border-radius:2px;}',
    '.casa-legal-tab.active{background:#122A45;color:#fff;border-color:#122A45;}',
    '.casa-legal-tab .tick{color:#2D6A4F;margin-left:6px;font-weight:700;}',
    '.casa-legal-tab.active .tick{color:#9FE0BE;}',
    '.casa-legal-body{overflow-y:auto;padding:18px 26px;flex:1;font-size:13.5px;line-height:1.72;color:#2a2a2a;}',
    '.casa-legal-body h1{font-family:Georgia,serif;font-size:19px;font-weight:400;text-align:center;color:#122A45;margin:0 0 4px;}',
    '.casa-legal-body .meta{text-align:center;font-style:italic;font-size:12px;color:#8a8a8a;margin-bottom:18px;}',
    '.casa-legal-body h2{font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#122A45;',
    'margin:22px 0 8px;font-weight:600;}',
    '.casa-legal-body p{margin:0 0 12px;}',
    '.casa-legal-body li{margin:0 0 8px 18px;}',
    '.casa-legal-foot{border-top:1px solid #e8e4dd;padding:18px 26px 22px;background:#faf8f5;}',
    '.casa-legal-req{font-size:12px;color:#8a2f2f;margin:0 0 12px;letter-spacing:.02em;}',
    '.casa-legal-check{display:flex;gap:10px;align-items:flex-start;font-size:13px;color:#2a2a2a;',
    'line-height:1.5;margin-bottom:14px;cursor:pointer;}',
    '.casa-legal-check input{margin-top:3px;flex:0 0 auto;width:16px;height:16px;}',
    '.casa-legal-sign{display:flex;gap:12px;align-items:flex-end;flex-wrap:wrap;}',
    '.casa-legal-sign label{display:block;font-size:10px;letter-spacing:.2em;text-transform:uppercase;',
    'color:#6b6b6b;margin-bottom:6px;}',
    /* 1.4.11: the signature field must be unmistakably a field. */
    '.casa-legal-sign input[type=text]{border:1px solid #959590;padding:10px 12px;font-family:Georgia,serif;',
    'font-size:16px;font-style:italic;min-width:240px;background:#fff;}',
    '.casa-legal-sign .dateline{font-size:12px;color:#6b6b6b;padding-bottom:11px;}',
    '.casa-legal-email{margin-bottom:14px;}',
    '.casa-legal-email label{display:block;font-size:10px;letter-spacing:.2em;text-transform:uppercase;',
    'color:#6b6b6b;margin-bottom:6px;}',
    '.casa-legal-email input{border:1px solid #959590;padding:10px 12px;font-size:16px;min-width:240px;background:#fff;}',
    '.casa-legal-email input[readonly]{background:#f3f1ed;color:#4a4a4a;}',
    '.casa-legal-actions{display:flex;gap:10px;justify-content:flex-end;margin-top:16px;align-items:center;}',
    '.casa-legal-btn{background:#122A45;color:#fff;border:none;padding:13px 24px;font-size:11px;',
    'letter-spacing:.2em;text-transform:uppercase;cursor:pointer;}',
    '.casa-legal-btn[disabled]{opacity:.45;cursor:not-allowed;}',
    '.casa-legal-cancel{background:none;border:none;color:#6b6b6b;font-size:12px;cursor:pointer;text-decoration:underline;}',
    '.casa-legal-err{color:#8a2f2f;font-size:12px;margin-right:auto;}',
    /* footer hub */
    '.casa-legal-hub{border-top:1px solid rgba(255,255,255,.14);margin-top:26px;padding-top:20px;}',
    '.casa-legal-hub h4{font-size:10px;letter-spacing:.28em;text-transform:uppercase;color:rgba(255,255,255,.62);margin:0 0 12px;}',
    '.casa-legal-hub a{display:inline-block;margin:0 18px 8px 0;font-size:12px;color:rgba(255,255,255,.8);',
    'text-decoration:none;border-bottom:1px solid transparent;cursor:pointer;}',
    '.casa-legal-hub a:hover{border-bottom-color:rgba(184,153,104,.7);color:#fff;}',
    '.casa-legal-hub .copyright{margin-top:12px;font-size:11px;color:rgba(255,255,255,.45);}',
    '@media (max-width:640px){.casa-legal-card{max-height:94vh;}.casa-legal-body{padding:14px 18px;}',
    '.casa-legal-head,.casa-legal-foot{padding-left:18px;padding-right:18px;}',
    '.casa-legal-sign input[type=text],.casa-legal-email input{min-width:100%;}}'
  ].join('');
  document.head.appendChild(style);

  var catalog = null;   // list of published documents
  var cache = {};       // slug -> full document

  function get(path){ return fetch(API + path, { credentials:'same-origin' }).then(function(r){ return r.json(); }); }
  function post(path, body){
    return fetch(API + path, { method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json'}, body:JSON.stringify(body) }).then(function(r){ return r.json(); });
  }
  function loadCatalog(){
    if (catalog) return Promise.resolve(catalog);
    return get('/legal').then(function(j){ catalog = (j && j.documents) || []; return catalog; });
  }
  function loadDoc(slug){
    if (cache[slug]) return Promise.resolve(cache[slug]);
    return get('/legal?slug=' + encodeURIComponent(slug)).then(function(j){
      cache[slug] = j && j.document ? j.document : null; return cache[slug];
    });
  }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  // Render the stored blocks back to HTML. The text is never altered here.
  function renderDoc(doc){
    if (!doc) return '<p>This document is not available. Please contact info@casaconsignment.com.</p>';
    var body = doc.body || {};
    var blocks = body.blocks || [];
    var out = [];
    out.push('<h1>' + esc(body.heading || doc.title) + '</h1>');
    if (body.meta) out.push('<div class="meta">' + esc(body.meta) + '</div>');
    var inList = false;
    blocks.forEach(function(b){
      if (b.type === 'h1' || b.type === 'meta') return;      // already in the header
      if (b.type === 'li'){ if(!inList){ out.push('<ul>'); inList=true; } out.push('<li>'+esc(b.text)+'</li>'); return; }
      if (inList){ out.push('</ul>'); inList=false; }
      if (b.type === 'h2') out.push('<h2>' + esc(b.text) + '</h2>');
      else if (b.type === 'spacer') out.push('');
      else out.push('<p>' + esc(b.text) + '</p>');
    });
    if (inList) out.push('</ul>');
    return out.join('\n');
  }

  /* ---------------- modal ---------------- */
  var modal, elTitle, elLead, elTabs, elBody, elFoot;
  function buildModal(){
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'casa-legal-modal';
    modal.innerHTML =
      '<div class="casa-legal-card" role="dialog" aria-modal="true" aria-labelledby="casa-legal-title">' +
        '<div class="casa-legal-head"><h3 id="casa-legal-title"></h3><p class="lead"></p></div>' +
        '<div class="casa-legal-tabs"></div>' +
        '<div class="casa-legal-body"></div>' +
        '<div class="casa-legal-foot"></div>' +
      '</div>';
    document.body.appendChild(modal);
    elTitle = modal.querySelector('h3');
    elLead  = modal.querySelector('.lead');
    elTabs  = modal.querySelector('.casa-legal-tabs');
    elBody  = modal.querySelector('.casa-legal-body');
    elFoot  = modal.querySelector('.casa-legal-foot');
    modal.addEventListener('click', function(e){ if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });
  }
  function openModal(){ buildModal(); modal.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeModal(){ if(!modal) return; modal.classList.remove('open'); document.body.style.overflow=''; }

  /* ---------------- read-only viewer (the Legal hub) ---------------- */
  function view(slug){
    openModal();
    elTitle.textContent = 'Legal Information & Disclaimers';
    elLead.textContent = 'The agreements and policies that govern use of this site.';
    elBody.innerHTML = '<p>Loading…</p>';
    elFoot.innerHTML = '<div class="casa-legal-actions"><button class="casa-legal-btn" data-close>Close</button></div>';
    elFoot.querySelector('[data-close]').onclick = closeModal;
    loadCatalog().then(function(docs){
      elTabs.innerHTML = docs.map(function(d){
        return '<button class="casa-legal-tab' + (d.slug===slug?' active':'') + '" data-slug="'+d.slug+'">'+esc(d.title)+'</button>';
      }).join('');
      Array.prototype.forEach.call(elTabs.querySelectorAll('.casa-legal-tab'), function(t){
        t.onclick = function(){ view(t.getAttribute('data-slug')); };
      });
      return loadDoc(slug || (docs[0]||{}).slug);
    }).then(function(doc){
      elBody.innerHTML = renderDoc(doc);
      elBody.scrollTop = 0;
    }).catch(function(){ elBody.innerHTML = '<p>Could not load this document.</p>'; });
  }

  /* ---------------- acceptance gate ---------------- */
  // gate(context, {email,name}) -> Promise: resolves when every required document
  // for that context has been signed, rejects if the person cancels.
  function gate(context, who){
    who = who || {};
    return new Promise(function(resolve, reject){
      get('/legal?required=' + encodeURIComponent(context) + (who.email ? '&email=' + encodeURIComponent(who.email) : ''))
      .then(function(req){
        // Fail closed (26 Sep 2026): an error reply from /api/legal has no `documents`
        // list. It used to read as "nothing to sign" and let the action through unsigned.
        if (!req || !Array.isArray(req.documents)) { reject(new Error('legal documents unavailable')); return; }
        var docs = req.documents;
        if (!docs.length) { resolve({ skipped: 'no documents required' }); return; }
        if (req.allAccepted) { resolve({ alreadyAccepted: true }); return; }

        var pending = docs.filter(function(d){ return !d.accepted; });
        var current = 0;
        var signed = {};
        // /api/legal keys every acceptance to an email and 400s without one
        // ("A valid email is required to record the signature."). A guest at
        // checkout has no casaUser, so until 23 Sep 2026 guests could never get
        // past this box. The email field sits above the name so both are captured
        // on every signature; a signed-in account's email is shown locked.
        var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;   // same test as api/legal.js
        var accountEmail = (window.casaUser && window.casaUser.email) || '';
        var signerEmail = String(who.email || accountEmail || '').trim();
        var label = CTX_LABEL[context] || { title: 'Please review and agree', verb: 'Agree & continue' };

        openModal();
        elTitle.textContent = label.title;
        elLead.innerHTML = 'In order to finalize, you need to agree with the Terms of Service and Agreements below. ' +
          'Please read ' + (pending.length > 1 ? 'each document' : 'the document') + ', then type your full legal name to sign electronically.';

        function paintTabs(){
          elTabs.innerHTML = pending.map(function(d,i){
            return '<button class="casa-legal-tab'+(i===current?' active':'')+'" data-i="'+i+'">' +
              esc(d.title) + (signed[d.slug] ? '<span class="tick">✓</span>' : '') + '</button>';
          }).join('');
          Array.prototype.forEach.call(elTabs.querySelectorAll('.casa-legal-tab'), function(t){
            t.onclick = function(){ current = parseInt(t.getAttribute('data-i'),10); paint(); };
          });
        }

        function paint(){
          var d = pending[current];
          paintTabs();
          elBody.innerHTML = '<p>Loading…</p>';
          loadDoc(d.slug).then(function(doc){
            elBody.innerHTML = renderDoc(doc);
            elBody.scrollTop = 0;
          });

          var already = !!signed[d.slug];
          var today = new Date();
          var dateStr = today.toLocaleDateString(undefined, { year:'numeric', month:'long', day:'numeric' });

          elFoot.innerHTML =
            (already
              ? '<p class="casa-legal-req" style="color:#2D6A4F">✓ Signed — ' + esc(signed[d.slug].signature) + ' on ' + esc(dateStr) + '</p>'
              : '<p class="casa-legal-req">Agreement required to continue.</p>') +
            '<label class="casa-legal-check"><input type="checkbox" ' + (already?'checked disabled':'') + '>' +
              // One document per signature, so the label names only this one. The
              // account context used to append " and the Privacy Policy", which on the
              // Privacy Policy tab read "the Privacy Policy and the Privacy Policy"
              // (api/legal.js signs privacy-policy as its own document there).
              '<span>I have read and agree to the <strong>' + esc(d.title) + '</strong>.</span></label>' +
            '<div class="casa-legal-email"><label for="casa-legal-email-in">Email</label>' +
              '<input id="casa-legal-email-in" type="email" inputmode="email" autocomplete="email" ' +
              'autocapitalize="off" spellcheck="false" placeholder="you@example.com" value="' + esc(signerEmail) + '"' +
              (already ? ' disabled' : (accountEmail ? ' readonly' : '')) + '></div>' +
            '<div class="casa-legal-sign">' +
              '<div><label>Type your full legal name to sign</label>' +
              '<input type="text" placeholder="Your full legal name" ' + (already?'disabled value="'+esc(signed[d.slug].signed_name)+'"':'') + '></div>' +
              '<div class="dateline">Signed ' + esc(dateStr) + '</div>' +
            '</div>' +
            '<div class="casa-legal-actions"><span class="casa-legal-err"></span>' +
              '<button class="casa-legal-cancel">Cancel</button>' +
              '<button class="casa-legal-btn" disabled>' + (pending.length>1 && current < pending.length-1 ? 'Sign & next' : label.verb) + '</button>' +
            '</div>';

          var cb   = elFoot.querySelector('input[type=checkbox]');
          var name = elFoot.querySelector('input[type=text]');
          var mail = elFoot.querySelector('input[type=email]');
          var btn  = elFoot.querySelector('.casa-legal-btn');
          var err  = elFoot.querySelector('.casa-legal-err');
          elFoot.querySelector('.casa-legal-cancel').onclick = function(){
            closeModal(); reject(new Error('declined'));
          };

          function refresh(){
            signerEmail = mail.value.trim();
            btn.disabled = already ? false
              : !(cb.checked && name.value.trim().length >= 2 && EMAIL_RE.test(signerEmail));
          }
          if (!already){ cb.onchange = refresh; name.oninput = refresh; mail.oninput = refresh; }
          refresh();

          btn.onclick = function(){
            err.textContent = '';
            if (already){ advance(); return; }
            btn.disabled = true; btn.textContent = 'Signing…';
            post('/legal', {
              slug: d.slug, context: context,
              signed_name: name.value.trim(),
              email: signerEmail || undefined
            }).then(function(j){
              if (j && j.acceptance){
                signed[d.slug] = j.acceptance;
                // The Privacy Policy is presented alongside the Terms of Use at
                // account creation, so record it in the same act of signing.
                if (context === 'account' && d.slug === 'terms-of-service'){
                  var pp = pending.filter(function(x){ return x.slug === 'privacy-policy'; })[0];
                  if (pp && !signed['privacy-policy']){
                    return post('/legal', { slug:'privacy-policy', context:context,
                      signed_name:name.value.trim(), email: signerEmail || undefined })
                      .then(function(j2){ if (j2 && j2.acceptance) signed['privacy-policy'] = j2.acceptance; });
                  }
                }
              } else {
                throw new Error((j && j.error) || 'Could not record the signature.');
              }
            }).then(function(){ advance(); })
            .catch(function(e){
              err.textContent = e.message || 'Could not record the signature.';
              try{ window.casaSignal && window.casaSignal('terms_sign_failed', context+': '+(e.message || 'no message')); }catch(x){}
              btn.disabled = false; btn.textContent = label.verb;
            });
          };
        }

        function advance(){
          var next = pending.findIndex(function(d){ return !signed[d.slug]; });
          if (next === -1){
            closeModal();
            resolve({ signed: Object.keys(signed).map(function(k){ return signed[k]; }) });
          } else { current = next; paint(); }
        }

        paint();
      }).catch(function(e){ reject(e); });
    });
  }

  /* ---------------- footer hub: "Legal Information & Disclaimers" ---------------- */
  function injectHub(){
    var footer = document.querySelector('footer');
    if (!footer || footer.querySelector('.casa-legal-hub')) return;
    loadCatalog().then(function(docs){
      if (!docs.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'casa-legal-hub';
      var year = new Date().getFullYear();
      wrap.innerHTML = '<h4>Legal Information &amp; Disclaimers</h4>' +
        docs.map(function(d){ return '<a data-slug="'+d.slug+'">'+esc(d.title)+'</a>'; }).join('') +
        '<div class="copyright">© ' + year + ' Casa Consignment LLC. All rights reserved. ' +
        'All trademarks and brand names are the property of their respective owners; ' +
        'Casa Consignment is not affiliated with, sponsored by, or endorsed by any brand offered for resale.</div>';
      var container = footer.querySelector('.container') || footer;
      container.appendChild(wrap);
      Array.prototype.forEach.call(wrap.querySelectorAll('a[data-slug]'), function(a){
        a.onclick = function(e){ e.preventDefault(); view(a.getAttribute('data-slug')); };
      });
    });
  }

  /* ---------------- wire the gates ---------------- */
  // A declined gate and an unreachable /api/legal are NOT the same event, and all
  // three gates below used to treat them alike: an empty .catch(). A decline is a
  // decision and needs no message; a failure means the document could not be loaded
  // at all, and swallowing it leaves the button looking dead — the consignor,
  // buyer or seller gets no error, no gate, and no filed request, and we get no
  // signal either. gate() rejects with Error('declined') on Cancel; everything
  // else reaching here is a fault worth surfacing. Fail CLOSED (the action is
  // still refused, because consent was never recorded) but say so out loud.
  function gateStopped(e, what){
    if (e && e.message === 'declined') return;          // their choice; stay put
    var msg = 'We could not load the ' + what + ' just now, so nothing was submitted. '
            + 'Please try again in a moment, or email info@casaconsignment.com.';
    try { (window.showToast || window.alert)(msg); } catch(_){ }
    try { console.warn('[casa][legal] gate failed:', what, e); } catch(_){ }
    try { window.casaSignal && window.casaSignal('terms_load_failed', what + ': ' + (e && e.message || e)); } catch(_){ }
  }
  function wire(){
    // 1) Account creation — Website Terms of Use + Privacy Policy.
    // The storefront binds the register form directly rather than through a named
    // function, so intercept the submit itself. Capture phase + stopImmediate is
    // what lets us run before the storefront's own handler and then replay it.
    if (!document.__casaLegalRegisterHook){
      document.__casaLegalRegisterHook = true;
      document.addEventListener('submit', function(e){
        var f = e.target;
        if (!f || f.tagName !== 'FORM') return;
        var pw = f.querySelector('input[type=password]');
        if (!pw) return;                                  // not a credential form
        // Sign-in has only email+password; registration collects a name too.
        var others = f.querySelectorAll('input[type=text], input[name*="name" i]');
        if (!others.length) return;                       // pure sign-in — no gate
        var em = f.querySelector('input[type=email]');
        var who = String((em && em.value) || '').trim().toLowerCase();
        // ⚠️ The latch is keyed to the ADDRESS that was signed for, not to the form.
        //
        // It used to be a bare boolean (f.__casaLegalDone) set once and never cleared,
        // which meant the gate ran for a form exactly once per page load. The replay
        // below re-submits the same form, so the flag has to survive that — but it
        // also survived every FAILED submission, and that is a consent bypass:
        //
        //   type an address that already exists -> gate shown, signed, replayed
        //   -> server returns 409 -> correct the address -> submit again
        //   -> this handler returns early -> account created with NO acceptance row.
        //
        // Reproduced 29 Aug 2026 against production: user 42 was created with
        // privacy-policy and terms-of-service both accepted:false. Any server-side
        // rejection reaches it — duplicate email, weak password, a dropped request.
        // Comparing the address instead lets the replay through (same value) while
        // a corrected address is treated as what it is: a different person to gate.
        if (f.__casaLegalDoneFor && f.__casaLegalDoneFor === who) return;
        e.preventDefault(); e.stopImmediatePropagation();
        gate('account', { email: em && em.value }).then(function(){
          f.__casaLegalDoneFor = who;
          // Replay the submit so the storefront's own handler runs normally.
          if (typeof f.requestSubmit === 'function') f.requestSubmit();
          else f.dispatchEvent(new Event('submit', { bubbles:true, cancelable:true }));
        }).catch(function(e){ gateStopped(e, 'Website Terms of Use and Privacy Policy'); });
      }, true);
    }

    // 2) Purchase — Terms of Sale, before handing off to Shopify
    if (typeof window.casaShopifyCheckout === 'function' && !window.casaShopifyCheckout.__legal){
      var origCo = window.casaShopifyCheckout;
      window.casaShopifyCheckout = function(btn){
        var self = this;
        var email = (window.casaUser && window.casaUser.email) || '';
        // Tapped Checkout, before the Terms of Sale. "Checkout Handoff" fires only once
        // Shopify is reached, so the gap between the two is the drop-off at the Terms.
        var bag = []; try { bag = JSON.parse(localStorage.getItem('casa_cart') || '[]'); } catch (e) {}
        window.casaTrack('Checkout Started', { items: Array.isArray(bag) ? bag.length : 0 });
        gate('purchase', { email: email })
          .then(function(){ origCo.call(self, btn); })
          .catch(function(e){ gateStopped(e, 'Terms of Sale'); });
      };
      window.casaShopifyCheckout.__legal = true;
    }

    // 3) Consignor — Consignor Terms of Service
    if (typeof window.casaSellToCasaSubmit === 'function' && !window.casaSellToCasaSubmit.__legal){
      var origSell = window.casaSellToCasaSubmit;
      window.casaSellToCasaSubmit = function(e){
        if (e && e.preventDefault) e.preventDefault();
        var self = this, args = arguments;
        var f = document.getElementById('sellcasa-form');
        var em = f && f.querySelector('input[type=email]');
        gate('consignor', { email: (em && em.value) || (window.casaUser && window.casaUser.email) })
          .then(function(){ origSell.apply(self, args); })
          .catch(function(e){ gateStopped(e, 'Consignor Terms of Service'); });
        return false;
      };
      window.casaSellToCasaSubmit.__legal = true;
    }

    // 3b) Consignor — the "Consign a Piece" wizard itself.
    //
    // Step 3 collects a `required` agreement checkbox, but a ticked box is not a
    // signature: it records no document, no version and no hash, so there is
    // nothing to show a consignor later about WHAT they agreed to — which is the
    // entire point of the versioned acceptance rows in api/legal.js.
    //
    // Until 28 Aug 2026 gate('consignor') was wired ONLY to casaSellToCasaSubmit,
    // the outright-buyout flow — which the site itself describes as "a direct
    // buyout, not a consignment". So buyout sellers were signing the Consignor
    // Terms, and actual consignors signed nothing at all. The database showed it:
    // ONE consignor-terms acceptance for the whole store.
    //
    // The gate goes on setStep(4) because setStep(4) IS the submission — it builds
    // the payload and calls casaIntakeLanded('consignment', …). Putting it on the
    // Step 3 "Submit Request →" button instead would only guard one caller and
    // leave the intake reachable from anywhere else that asks for step 4.
    if (typeof window.setStep === 'function' && !window.setStep.__legal){
      var origStep = window.setStep;
      window.setStep = function(n){
        if (n !== 4) return origStep.apply(this, arguments);   // plain navigation
        var self = this, args = arguments;
        var wrap = document.querySelector('.sell-form-wrap');
        var em = wrap && wrap.querySelector('input[type=email]');
        gate('consignor', { email: (em && em.value) || (window.casaUser && window.casaUser.email) })
          .then(function(){ origStep.apply(self, args); })
          .catch(function(e){ gateStopped(e, 'Consignor Terms of Service'); });   // declined -> stay on Step 3, nothing submitted
        return;
      };
      window.setStep.__legal = true;
    }

    // 4) Membership — Concierge Membership Terms
    if (typeof window.casaStartMembership === 'function' && !window.casaStartMembership.__legal){
      var origMem = window.casaStartMembership;
      window.casaStartMembership = function(tier){
        var self = this;
        // Only gate an actual enrolment. Billing went live 3 Aug 2026, so for
        // all three tiers this now gates a real recurring charge — which is
        // exactly when Membership Terms §3.1 ("YOUR PAYMENT METHOD WILL BE
        // CHARGED ON A RECURRING BASIS") must be signed.
        //
        // The empty-URL branch is kept deliberately: if a tier is ever pulled
        // by blanking its URL, the button falls back to the waitlist form, and
        // making someone sign an auto-renewal contract to join a waitlist would
        // record a signature against a membership that does not exist and a card
        // that will never be charged. The signature attaches to the enrolment,
        // never to an expression of interest.
        var p = ((window.CASA_CONFIG || {}).MEMBERSHIP_PLANS || {})[tier];
        if (!(p && p.variantId && p.sellingPlanId)) { origMem.call(self, tier); return; }
        gate('membership', { email: (window.casaUser && window.casaUser.email) })
          .then(function(){ origMem.call(self, tier); })
          .catch(function(e){ gateStopped(e, 'Concierge Membership Terms'); });
      };
      window.casaStartMembership.__legal = true;
    }
  }

  function boot(){ injectHub(); wire(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // The storefront wires several of these functions after load, so keep trying.
  setTimeout(wire, 800); setTimeout(wire, 2000); setTimeout(boot, 3000);

  // Inline references to an agreement anywhere in the copy open the real document,
  // so a customer never has to hunt the footer to read what a claim is based on.
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest(
      '.lnk-consignor-terms,.lnk-membership-terms,.lnk-buyer-terms,.lnk-privacy-policy,.lnk-terms-of-service');
    if (!a) return;
    e.preventDefault();
    var map = {
      'lnk-consignor-terms':   'consignor-terms',
      'lnk-membership-terms':  'membership-terms',
      'lnk-buyer-terms':       'buyer-terms-of-purchase',
      'lnk-privacy-policy':    'privacy-policy',
      'lnk-terms-of-service':  'terms-of-service'
    };
    for (var cls in map) if (a.classList.contains(cls)) { view(map[cls]); return; }
  });

  window.casaLegalView = view;
  window.casaLegalGate = gate;
})();
